import { useRef, useEffect, useCallback, PropsWithChildren, FC, useState } from 'react'
import { Spin } from 'antd'
import { Line } from '@antv/g2plot';
import Card from '@/pages/Tbqy/components/components/Card'
import CardContainer from '@/pages/Bmjy/components/components/CardContainer'

const data = [];
const data1 = []

const LRV_KEY = '本年利润率(%)'

for(let i=0; i<12; i++) {
  data.push({
    "label": i+ 1 + "月",
    "type": "本年",
    "value": Math.floor(Math.random()*100)
  })
  data.push({
    "label": i+ 1 + "月",
    "type": "上年",
    "value": Math.floor(Math.random()*100)
  })
}

const tabsOptions = [
  {
    label: '按公司', 
    value: 'ags',
    api: null
  }, 
  {
    label: '按院', 
    value: 'ay',
    api: null
  }, 
  {
    label: '按所', 
    value: 'as',
    api: null
  }
]

type PropType = FC<PropsWithChildren<{
  updateTime: string
}>>

const Component: PropType = ({updateTime}) => {
  const containerRef = useRef()
  const [loading, setLoading] = useState(false)
  const globalRef = useRef({
    params: {
      tab: '',
      depart: ''
    },
    column: null as Line,
    loadTime: updateTime
  })

  useEffect(() => {
    globalRef.current.column = new Line(containerRef.current, {
      data: [],
      xField: 'label',
      yField: 'value',
      seriesField: 'type',
      legend: {
        position: 'bottom',
      },
      yAxis: {
        label: {
          formatter: (val) => {
            return `${val}份`;
          },
        }
      },
      point: {
        shape: 'circle',
        size: 4,
      }
    });

    globalRef.current.column.render();
    globalRef.current.column.changeData(data)
  }, [])
  
  // 获取图表数据
  const getColumnData = useCallback(async () => {
    const tabOption = tabsOptions.find(t => t.value === globalRef.current.params.tab)
    if(!tabOption || !tabOption.api) {
      return
    }

    const res = await tabOption.api()
    if(res.success) {
      globalRef.current.column.changeData(res.data.list.reduce((c, n) => {
        c.push({
          label: n.time,
          value: n.jnZBnum || n.jnTBnum || 0,
          type: '今年'
        })
        c.push({
          label: n.time,
          value: n.qnZBnum || n.qnTBnum || 0,
          type: '去年'
        })
        return c
      }, []))
    }
  }, [])

  // 获取统计数据
  const getTotal = useCallback(async () => {
    
  }, [])

  // 获取接口数据
  const getList = useCallback(async () => {
    setLoading(true)
    Promise.all([getColumnData(), getTotal()]).finally(() => {
      setLoading(false)
    })
  }, [getColumnData, getTotal])

  // 变更类型
  const handleTabChange = useCallback((value) => {
    globalRef.current.params = value
    getList()
  }, [getList])

  useEffect(() => {
    if(globalRef.current.loadTime !== updateTime) {
      globalRef.current.loadTime = updateTime
      getList()
    }
  }, [updateTime, getList])

  return (
    <Spin spinning={loading} wrapperClassName='full-spin'>
      <CardContainer
        tabs={tabsOptions}
        onTabChange={handleTabChange}
        title='月度统计'
        hasDepartSelect
      >
        <div className='h-full pt-20'>
          <div className='h-full' ref={containerRef}></div>
        </div>
      </CardContainer>
    </Spin>
  )
}

export default Component
